export default __webpack_public_path__ + "assets/labels.61f1608ce793de6c2c57bb4a9a424b29.png";